import React, { useCallback } from 'react';
import type { HoldingsDataProps } from '../../types';
import { DATA_TYPE_EXCEL_STYLES } from '../../logic/customBlockUtils';
import ExportableGrid from './ExportableGrid';
import { useCommonTreeGridProps } from '../../logic/columnUtils';
import type { CellClassParams } from '../../../data-grid';
import { useIsBlockGridCompact } from '../../logic/useIsBlockGridCompact';
import { useHoldingsTreeGrid } from '../../logic/useHoldingsTreeGrid';

const extraDefaultColDef = {
  cellStyle: (params: CellClassParams) => (params.data.isParent ? { 'font-weight': 'bold' } : null),
};

const HoldingsTreeGrid = ({ selectedRefId, ...exportProps }: HoldingsDataProps) => {
  const { rowData, columnDefs, autoGroupColumnDef } = useHoldingsTreeGrid({
    selectedRefId,
    isBarChart: false,
  });

  const treeGridProps = useCommonTreeGridProps(extraDefaultColDef);
  const isCompact = useIsBlockGridCompact();

  return (
    <ExportableGrid
      {...treeGridProps}
      {...exportProps}
      isCompact={isCompact}
      rowData={rowData}
      selectedRefId={selectedRefId}
      exportable={false}
      columnDefs={columnDefs}
      onGridReady={useCallback(
        // @ts-expect-error: fixme
        (event) => {
          // TODO(collin.irwin): seems redundant with the sizeColumnsToFit in ExportableGrid?
          event.api.sizeColumnsToFit();
        },
        [],
      )}
      excelStyles={DATA_TYPE_EXCEL_STYLES}
      autoGroupColumnDef={autoGroupColumnDef}
    />
  );
};

export default HoldingsTreeGrid;
